import React, { useContext, useEffect } from "react";
import "./style.css";
import axios from "axios";
import moment from "moment";
import { Markup } from "interweave";
import { useState } from "react";

import { Card } from "react-bootstrap";
import { CardContent } from "@material-ui/core";
import RegisterNowPay from "../../../components/RegisterLearningDetails/RegisterNowPay/RegisterNowPay";
import { LocationContext } from "../../../CustomHelper/Helper";
import Navigation from "../../Layouts/Header/Navigation";
import QnADetailsSkeliton from "../Qna/QnADetailsSkeliton";
import { serverInfo } from "../../../App";

const MeetupDetails = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [post, setPost] = useState({});

  const [LoadingQnaDetails, setLoadingQnaDetails] = useState([]);

  const { slectedCurrency, payStatus } = useContext(LocationContext);
  const [countryBaseCost, setCountryBaseCost] = useState(false);

  useEffect(() => {
    const event_id = props.match.params.slug;

    axios.get(`/api/user/meetup/${event_id}`).then((res) => {
      if (res.data.status === 200) {
        setLoadingQnaDetails(false);
        setPost(res.data.event);
      }
    });
  }, [props.match.params.slug]);

  useEffect(() => {
    setCountryBaseCost(
      (Number(post.fee) * Number(slectedCurrency?.currency_value)).toFixed(0)
    );
  }, [post, slectedCurrency]);

  return (
    <>
      <Navigation />
      {LoadingQnaDetails ? (
        <QnADetailsSkeliton />
      ) : (
        <div className="container">
          <div className="mt-3">
            <img
              src={imageCdnUrl + post.banner}
              className="img-fluid w-100 "
              alt={imageCdnUrl + post.banner}
            />
          </div>
          <div className=" mt-3 ">
            <div className="card-bg1  shadow p-3 card">
              <div className="card-body">
                <h5 className="text-light pb-3">{post.title}</h5>

                <h5 className="text-warning">Instruction</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={post.instruction} />
                </p>

                <h5 className="text-warning">Description</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={post.description} />
                </p>

                <div className="row">
                  <div className="col-md-3  ">
                    <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                      <h5 className="text-warning pt-2 ">Star Name</h5>
                      <p className="text-light fw-bold pt-2">
                        {post.star?.first_name} {post.star?.last_name}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                      <h5 className="text-warning pt-2 ">Event Date</h5>
                      <p className="text-light fw-bold pt-2">
                        {moment(post.event_date).format("LL")}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                      <h5 className="text-warning pt-2 ">Time</h5>
                      <p className="text-light fw-bold pt-2">
                        {moment(post.start_time, "HH:mm:ss").format("hh:mm A")}{" "}
                        - {moment(post.end_time, "HH:mm:ss").format("hh:mm A")}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                      <h5 className="text-warning pt-2 ">Fee</h5>
                      <p className="text-light fw-bold pt-2">
                        {countryBaseCost} {" " + slectedCurrency?.symbol}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {countryBaseCost && (
            <>
              {payStatus && (
                <Card
                  className="my-4"
                  style={{ backgroundColor: "#25272b" }}
                  sx={{ minWidth: 275 }}
                >
                  <RegisterNowPay
                    fee={countryBaseCost}
                    baseFee={post.fee}
                    post={post}
                    event_type="meetup"
                  />
                </Card>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default MeetupDetails;
